<script>
export default {
  name: 'CardImages',
  props: {
    images: {
      type: Array,
      required: true,
    },
    object: {
      type: String,
      default: 'cover',
    },
    cursor: {
      type: String,
      default: 'pointer',
    },
  },
  data() {
    return {
      imagesToSwiper: this.images,
    }
  },

  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    imagesHeight() {
      return this.isMobileVersion ? 'ww-height-2' : 'h-40'
    },
    localObject() {
      let objectClass = 'object-contain'
      switch (this.object) {
        case 'cover':
          objectClass = 'object-cover'
          break
        case 'contain':
          objectClass = 'object-contain'
          break
      }
      return objectClass
    },
    localCursor() {
      let cursorClass = 'cursor-default'
      switch (this.cursor) {
        case 'move':
          cursorClass = 'cursor-move'
          break
        case 'pointer':
          cursorClass = 'cursor-pointer'
          break
        case 'default':
          cursorClass = 'cursor-default'
          break
      }
      return cursorClass
    },
  },
}
</script>

<template>
  <div class="relative rounded overflow-hidden" :class="[localCursor]">
    <div v-if="imagesToSwiper.length === 1" :class="imagesHeight">
      <img
        class="w-full h-full"
        :class="[localObject]"
        alt="img"
        :src="imagesToSwiper[0].anUrl"
      />
    </div>

    <div v-else :class="imagesHeight">
      <img
        class="w-full h-full object-cover cursor-move"
        alt="img"
        src="https://io.winwinapp.ru/images/Photo.png"
      />
    </div>
  </div>
</template>

<style scoped>
.ww-height-2 {
  height: 2rem;
}
</style>
